"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactAsyncScriptLoader = _interopRequireDefault(require("react-async-script-loader"));

var _withReduxForm = _interopRequireDefault(require("../../libs/hocs/withReduxForm"));

var _getUrl = _interopRequireDefault(require("./getUrl"));

var _wrapper = _interopRequireDefault(require("./wrapper"));

/**
 * The ReCaptcha component is used to protects your website from spam and abuse.
 */
var ReCaptcha =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ReCaptcha, _Component);

  function ReCaptcha(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ReCaptcha);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ReCaptcha).call(this, props));
    var lang = props.lang;
    _this.ReCaptchaComponent = (0, _reactAsyncScriptLoader["default"])((0, _getUrl["default"])(lang))(_wrapper["default"]);
    return _this;
  }

  (0, _createClass2["default"])(ReCaptcha, [{
    key: "render",
    value: function render() {
      var ReCaptchaComponent = this.ReCaptchaComponent;
      return _react["default"].createElement(ReCaptchaComponent, this.props);
    }
  }]);
  return ReCaptcha;
}(_react.Component);

ReCaptcha.propTypes = {
  /** Specifies the site key for the recaptcha. */
  siteKey: _propTypes["default"].string.isRequired,

  /** Forces the widget to render in a specific language.
   * Auto-detects the user's language if unspecified. */
  lang: _propTypes["default"].string,

  /** The color theme of the widget. */
  theme: _propTypes["default"].oneOf(['light', 'dark']),

  /** The size of the widget. */
  size: _propTypes["default"].oneOf(['normal', 'compact']),

  /** The tabindex of the widget and challenge.
   * If other elements in your page use tabindex,
   * it should be set to make user navigation easier. */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Specifies that the recaptcha must be completed before submitting the form. */
  error: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),

  /** The action triggered when the value of the recaptcha changes. It receive the
   * recaptcha token when is fired.
   */
  onChange: _propTypes["default"].func,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied for the outer element. */
  style: _propTypes["default"].object
};
ReCaptcha.defaultProps = {
  lang: undefined,
  theme: 'light',
  size: 'normal',
  tabIndex: 0,
  error: undefined,
  onChange: function onChange() {},
  className: undefined,
  style: undefined
};

var _default = (0, _withReduxForm["default"])(ReCaptcha);

exports["default"] = _default;